<template>
  <div
    class="flex items-center bg-white relative hover:text-amber select-none cursor-pointer p-2 gap-2"
    @click="showGlobalSearch = true"
  >
    <AppIcon
      icon="search"
      fixed-width
    />
    <span>Zoeken...</span>
    <KeyboardBinding
      class="ml-auto"
      key-combinbation="Ctrl+F"
    />
  </div>
</template>

<script setup lang="ts">
import { useAppStore } from "~/stores/App";

const { showGlobalSearch } = storeToRefs(useAppStore());
</script>

<style scoped></style>
